import React from "react"

export const languages = {
  en: {
    locale: "en",
    lastUpdate: "Last updated",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Book a free consultation online",
    join: "Join",
    caseStudy: "Read the case study",
    watchVideo: "Watch video",
    stories: "Stories",
  },
  he: {
    locale: "he",
    lastUpdate: "עודכן לאחרונה",
    discoverMore: "למידע נוסף",
    all: "All",
    search: "חיפוש",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB עבור",
    followUs: "Follow us",
    chat: "Book a free consultation online",
    join: "Join",
    caseStudy: "Read the case study",
    watchVideo: "צפה בסרטון",
    stories: "Stories",
  },
  de: {
    locale: "de",
    lastUpdate: "Zuletzt aktualisiert",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Eine kostenlose Beratung online buchen",
    join: "Join",
    caseStudy: "Lesen Sie die Fallstudie",
    watchVideo: "Video ansehen",
    stories: "Stories",
  },
  es: {
    locale: "es",
    lastUpdate: "Última actualización",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Descargar",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Reserve una consulta gratuita en línea",
    join: "Join",
    caseStudy: "Leer el caso",
    watchVideo: "Ver el vídeo",
    stories: "Stories",
  },
  pt: {
    locale: "pt",
    lastUpdate: "Última atualização",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Descarregar",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Marcar uma consulta on-line gratuita",
    join: "Join",
    caseStudy: "Leia o estudo de caso",
    watchVideo: "Assistir ao vídeo",
    stories: "Stories",
  },
  pl: {
    locale: "pl",
    lastUpdate: "Ostatnia aktualizacja",
    discoverMore: "Więcej informacji",
    all: "Wszystkie",
    search: "Szukaj",
    results: "Wyniki",
    noResults: "Brak wyników",
    download: "Pobierz",
    latestArticles: "Najnowsze wiadomości",
    previous: "poprzedni",
    next: "następny",
    allCategories: "Wszystkie kategorie",
    abFor: "AB dla",
    followUs: "Śledź nas",
    chat: "Zarezerwuj bezpłatną konsultację online",
    join: "Dołącz",
    caseStudy: "Przeczytaj studium przypadku",
    watchVideo: "Obejrzyj wideo",
    stories: "Stories",
  },
  ru: {
    locale: "ru",
    lastUpdate: "Последнее обновление",
    discoverMore: "Discover more",
    all: "All",
    search: "поиск",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Заказать бесплатную консультацию онлайн",
    join: "Join",
    caseStudy: "Ознакомьтесь с примером из практики",
    watchVideo: "Смотреть видео",
    stories: "Stories",
  },
  "en-us": {
    locale: "en-US",
    lastUpdate: "Last updated",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Book a free consultation online",
    join: "Join",
    caseStudy: "Read the case study",
    watchVideo: "Watch video",
    stories: "Stories",
  },
  "en-ca": {
    locale: "en-CA",
    lastUpdate: "Last updated",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Book a free consultation online",
    join: "Join",
    caseStudy: "Read the case study",
    watchVideo: "Watch video",
    stories: "Stories",
  },
  fr: {
    locale: "fr",
    lastUpdate: "Dernière mise à jour",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Télécharger",
    latestArticles: "Latest news",
    previous: "previous",
    next: "next",
    allCategories: "All categories",
    abFor: "AB for",
    followUs: "Follow us",
    chat: "Réservez un conseil gratuite en ligne",
    join: "Join",
    caseStudy:
      "Remplissez le formulaire pour recevoir la brochure d'information gratuite",
    watchVideo: "Regarder la vidéo",
    stories: "Stories",
  },
  it: {
    locale: "it",
    lastUpdate: "Ultimo aggiornamento",
    discoverMore: "Scopri di più",
    all: "Tutti",
    search: "Cerca",
    results: "risultati",
    noResults: "Nessun risultato",
    download: "Scarica",
    latestArticles: "Ultime news",
    previous: "precedente",
    next: "successivo",
    allCategories: "Tutte le categorie",
    abFor: "AB for",
    followUs: "Seguici su",
    chat: "Prenota una consulenza gratuita online",
    join: "Accedi",
    caseStudy: "Leggi il caso studio",
    watchVideo: "Guarda il video",
    stories: "Stories",
  },
  el: {
    locale: "el",
    lastUpdate: "Τελευταία ενημέρωση",
    discoverMore: "Μάθε περισσότερα",
    all: "Όλα",
    search: "Αναζήτηση",
    results: "Αποτελέσματα",
    noResults: "Καμία αποτέλεσμα",
    download: "Λήψη",
    latestArticles: "Νέες ειδήσεις",
    previous: "προηγούμενο",
    next: "επόμενο",
    allCategories: "Όλες οι κατηγορίες",
    abFor: "AB για",
    followUs: "Ακολουθήστε μας",
    chat: "Κάντε κλήση για μια δωρεάν συνεδρία",
    join: "Συνδεθείτε",
    caseStudy: "Διαβάστε το παράδειγμα",
    watchVideo: "Δείτε το βίντεο",
    stories: "Stories",
  },
  cs: {
    locale: "cs",
    lastUpdate: "Poslední aktualizace",
    discoverMore: "Zjistit více",
    all: "Vše",
    search: "Hledat",
    results: "Výsledky",
    noResults: "Žádné výsledky",
    download: "Stáhnout",
    latestArticles: "Nejnovější zprávy",
    previous: "předchozí",
    next: "další",
    allCategories: "Všechny kategorie",
    abFor: "AB pro",
    followUs: "Sledujte nás",
    chat: "Rezervujte si bezplatnou konzultaci online",
    join: "Přihlásit se",
    caseStudy: "Přečtěte si případovou studii",
    watchVideo: "Přehrát video",
    stories: "Stories",
  },
}

export const i18nContext = React.createContext(languages.it)
